<label class="checkbox" [ngClass]="{'disabled': data.disabled}" *ngIf="data">
  <input type="checkbox" [name]="data.id.toString()" [(ngModel)]="state" (ngModelChange)="onChanged()" [disabled]="data.disabled">
  <span class="checkbox__custom"><brt-icon [icon]="checkIcon"></brt-icon></span>
  <span class="checkbox__label" [innerHTML]="data.label"></span>
</label>
